export const NoteTypes = {
  referrer: 'REFERRER',
  consultant: 'CONSULTANT',
  triageAdmin: 'TRIAGE',
  system: 'SYSTEM'
};
